// Axios client dedicado pra ms-meta-reports (https://reports.kodefy.cloud).
// Reusa o `access_token` do front-rocket (mesmo localStorage que o resto da app).
//
// Decisão arquitetural: separado do `client.ts` principal porque aponta pra
// outra base URL (reports é microserviço separado), mas usa o MESMO token.
// Quando o backend validar o JWT por user_id (ainda TODO no ms-meta-reports),
// o filtro de visibilidade vem de graça — front só manda o Bearer.

import axios, { AxiosError } from "axios";
import { clearAuthData } from "@/services/api/auth";

const REPORTS_API_BASE = "https://reports.kodefy.cloud";

const reportsClient = axios.create({
    baseURL: REPORTS_API_BASE,
    headers: { "Content-Type": "application/json" },
});

reportsClient.interceptors.request.use((config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// 401 = sessão vencida/inválida → desloga e manda pro login, igual ao client
// principal. (Antes o reports rodava com AUTH_DISABLED e token vencido virava
// admin — vazava dados de todos. Agora o reports exige token válido.)
// 403 NÃO desloga: é "sem permissão de dashboard", o caller mostra banner.
reportsClient.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        if (error.response?.status === 401) {
            clearAuthData();
            window.location.href = "/login";
        }
        // Normaliza erros pra UI mostrar mensagem útil (kind=auth|network|http)
        const status = error.response?.status;
        (error as AxiosError & { kind?: string }).kind =
            status === 401 || status === 403
                ? "auth"
                : !error.response
                  ? "network"
                  : "http";
        return Promise.reject(error);
    }
);

export default reportsClient;
export { REPORTS_API_BASE };
